import React, { Component } from 'react';
import moment from 'moment';
import L from '../services/localizationService';
import CurrencyInput from './currencyinput';

class BillingsForecast extends Component {
  constructor(props) {
    super(props);

    this.defaultForecastLines = {};
    for (let i=0; i < 14; i++) {
      for (let j=0; j < 4; j++) {
        let keyName = this.getForecastLineId(i, j);
        this.defaultForecastLines[keyName] = '';
      }
    }

    this.defaults = {
      billingsForecastStartMoment : moment().startOf('month'),

      remainingToBillGross: 0,
      remainingToBillNet: 0,
      remainingToBillRet: 0,

      // From props
      totalContract: 0,
      invoicedToDateNet: 0,
      invoicedToDateRet: 0,
    }

    this.state = {
      project: props.project,
      invoicedToDateGross: props.invoicedToDateGross / ( 1 - (this.defaults.retentionPct / 100)),
      totalContract: props.totalContract,
      forecastLines: this.props.forecastLines || this.defaultForecastLines,
      retentionPct: this.props.billingsForecast ? this.props.billingsForecast.retentionPct : 10,
      ...Object.assign({}, this.defaults),
    }

    this.recalcForecasts = this.recalcForecasts.bind(this);
  }
  
  componentDidUpdate(prevProps) {
    if (this.props.billingsForecast && (!prevProps.billingsForecast ||
       (this.props.billingsForecast.retentionPct !== prevProps.billingsForecast.retentionPct))) {
      this.setState({
        retentionPct: this.props.billingsForecast.retentionPct || 10,
      });
    }

    if (this.props.forecastLines !== prevProps.forecastLines) {
      this.setState({
        forecastLines: this.props.forecastLines || this.defaultForecastLines,
      });
    }

    if (this.props.project !== prevProps.project) {
      this.setState({
        project: this.props.project,
        totalContract: this.props.totalContract,
        forecastLines: this.props.forecastLines || this.defaultForecastLines,
        ...Object.assign({}, this.defaults)
      });
    }

    if (this.props.totalContract !== prevProps.totalContract) {
      this.setState({
        totalContract: this.props.totalContract
      }, () => {
        this.recalcForecasts();
      })
    }

    if (this.props.invoicedToDateGross !== prevProps.invoicedToDateGross) {
      this.setState({
        invoicedToDateGross: this.props.invoicedToDateGross / (1 - (this.state.retentionPct / 100))
      }, () => {
        this.recalcForecasts();
      })
    }
  }

  getForecastLineId(column, row) {
    return `forecastLine${column}_${row}`
  }

  updateForecastLine(column, row, value) {
    let forecastValues = this.state.forecastLines;
    let keyName = this.getForecastLineId(column, row);
    forecastValues[keyName] = value;

    this.setState({ forecastLines: forecastValues });
  }

  recalcForecasts() {
    let invoicedToDateGross = this.props.invoicedToDateGross; /*  / ( 1 - (this.state.retentionPct / 100));*/
    let invoicedToDateNet = invoicedToDateGross;// * (1 - (this.state.retentionPct / 100));
    let invoicedToDateRet = (invoicedToDateGross * ((this.state.retentionPct / 100))) /* - RetentionBilled*/;

    let remainingToBillGross = this.state.totalContract - invoicedToDateGross;
    let remainingToBillNet = remainingToBillGross * (1 - (this.state.retentionPct / 100));
    let remainingToBillRet = remainingToBillGross * (this.state.retentionPct / 100) /* - RetentionBilled*/;

    let lineOneSum = 0, lineThreeSum = 0;
    let forecastLines = this.state.forecastLines;

    for (let i=0; i <= 12; i++) {
      try {
        let keyNames = [];
        for (let j=0; j < 4; j++) { keyNames.push(this.getForecastLineId(i, j))}

        let lineOneValue = L.parseFloatWithZero(forecastLines[keyNames[0]]);
        let lineTwoValue = lineOneValue * (1 - (this.state.retentionPct / 100));
        let lineThreeValue = L.parseFloatWithZero(forecastLines[keyNames[2]] || 0);
        let lineFourValue = lineTwoValue + lineThreeValue;

        forecastLines[keyNames[1]] = lineTwoValue;
        forecastLines[keyNames[3]] = lineFourValue;

        lineOneSum += lineOneValue;
        //lineTwoSum = lineOneSum * (1 - (this.state.retentionPct / 100));
        lineThreeSum += lineThreeValue;
        //lineFourSum = lineTwoSum + lineThreeSum;
      }
      catch (e) {
        console.errpr('Error updating forecasts: ', e)
      }
    }

    // Balance section
    let balanceLineOne = remainingToBillGross - lineOneSum;
    let balanceLineTwo = balanceLineOne * (1 - (this.state.retentionPct / 100));
    let balanceLineThree = remainingToBillRet - lineThreeSum;
    let balanceLineFour = balanceLineTwo + balanceLineThree;

    forecastLines[this.getForecastLineId(13, 0)] = Math.abs(remainingToBillGross) - lineOneSum;
    forecastLines[this.getForecastLineId(13, 1)] = balanceLineTwo;
    forecastLines[this.getForecastLineId(13, 2)] = balanceLineThree;
    forecastLines[this.getForecastLineId(13, 3)] = balanceLineFour;

    this.setState ({
      remainingToBillGross: remainingToBillGross,
      remainingToBillNet: remainingToBillNet,
      remainingToBillRet: remainingToBillRet,
      invoicedToDateGross : invoicedToDateGross,
      invoicedToDateNet: invoicedToDateNet,
      invoicedToDateRet: invoicedToDateRet,
      forecastLines: forecastLines
    }, () => {
      if (this.props.onRecalculated) {
        this.props.onRecalculated(this.state);
      }
    })

  }

  forecastTableCell(title, i, isBalance) {
    let idNames = [];
    for (let j=0; j < 4; j++) { idNames.push(this.getForecastLineId(i, j)); }
      return <div key={title} className="forecastTableCell">
      <div className="forecastTableCell-title">{title}</div>
      {i < 7 && <hr/>}

      {isBalance && 
        <input id={idNames[0]} value={L.toCurrencyString(this.state.forecastLines[idNames[0]])} readOnly />
      }

      {!isBalance && 
        <CurrencyInput id={idNames[0]} value={this.state.forecastLines[idNames[0]]}
          onChanged={(newValue) => { this.updateForecastLine(i, 0, newValue); this.recalcForecasts() }} />
      }

      {/* <input id={idNames[1]} 
      value={L.toCurrencyString(this.state.forecastLines[idNames[1]])} readOnly />
      

      {isBalance && 
            <input id={idNames[2]} 
            value={L.toCurrencyString(this.state.forecastLines[idNames[2]])} readOnly />
      }            

      {!isBalance && 
            <input id={idNames[2]} 
            value={this.state.forecastLines[idNames[2]]}
                    onChange={(e) => this.updateForecastLine(i, 2, e.target.value) }
                    onBlur={this.recalcForecasts} />
      }            

      <input className="top-border" id={idNames[3]} 
        value={L.toCurrencyString(this.state.forecastLines[idNames[3]])} readOnly /> */}
                
      </div>
  }
  render() {
    
    let forecastChartRow1 = [];
    let forecastChartRow2 = [];

    let startMonthMoment = moment(this.state.billingsForecastStartMoment);
    forecastChartRow1.push(this.forecastTableCell(startMonthMoment.format('MMM-YY'), 0));
    for (let i=1; i < 13; i++) {
        let rowArray = forecastChartRow1;
        if (i > 6) {
            rowArray = forecastChartRow2;
        }
            startMonthMoment.add(1, 'M');
            rowArray.push(this.forecastTableCell(startMonthMoment.format('MMM-YY'), i));
    }
    forecastChartRow2.push(this.forecastTableCell('BALANCE', 13, true));

    return (
        <>
        <div className="billingsForecast">
          <div className="billingsForecast-left">
            <label>Retention %</label>
            <hr/>

            <input id="retentionPct"
              value={`${this.state.retentionPct}`} 
              onChange={(e) => this.setState({ retentionPct: e.target.value })}
              onBlur={() => { this.recalcForecasts();}} />
          </div>
      
          <div className="billingsForecast-left">
            <label>Invoiced To Date</label>
            <hr/>

            {/* <input id="bfInvoicedToDateGross"
              value={L.toCurrencyString(this.state.invoicedToDateGross)} readOnly /> */}
            <input id="bfInvoicedToDateNet" 
              value={L.toCurrencyString(this.state.invoicedToDateNet)} readOnly />
            {/* <input id="bfInvoicedToDateRet"
              value={L.toCurrencyString(this.state.invoicedToDateRet)} readOnly /> */}

          </div>

          <div className="billingsForecast-left">
            <label>Remaining To Bill</label>
            <hr/>

            <input id="remainingToBillGross"
              value={L.toCurrencyString(this.state.remainingToBillGross)} readOnly />
            {/* <input id="remainingToBillNet" 
              value={L.toCurrencyString(this.state.remainingToBillNet)} readOnly /> */}
            {/* <input id="remainingToBillRet"
              value={L.toCurrencyString(this.state.remainingToBillRet)} readOnly /> */}
          </div>

        <div className="forecastTable">
          <div className="forecastTableRow">
            {forecastChartRow1}
          </div>
          <div className="forecastTableRow top-margin">
            {forecastChartRow2}
          </div>
        </div>
      </div>
      </>
    );
  }
}

export default BillingsForecast;
